import { Case, CaseDiagnosis } from "pwapi";

import { isModifyingReport } from "components/viewer/dialogs/utils";
import { useAppSelector } from "store/hooks";

export const useDefaultSignature = () => {
  const caseDetailObject = useAppSelector(({ caseDetail }) => caseDetail);
  const features = useAppSelector(({ sys }) => sys.features);
  const user = useAppSelector(({ auth }) => auth.user);

  const isModifyingRep = isModifyingReport(caseDetailObject, features, user);
  const userSignatures =
    caseDetailObject.source === Case.source.PW
      ? useAppSelector(
          ({ userSignatures }) =>
            userSignatures?.[
              isModifyingRep?.source === CaseDiagnosis.source.CORRECTION
                ? caseDetailObject.report_signed_signature?.user_id || 0
                : user?.id || 0
            ]
        )
      : undefined;
  const defaultSignature =
    userSignatures?.find(
      (s) => s.id === caseDetailObject.finalizing_signature_id
    ) || userSignatures?.[0];

  return defaultSignature;
};
